const GET_PROJECT_DATA = 'getOriginData/GET_PROJECT_DATA';

const initialState = {
    projectDatafromNet: null
};
const reducer = function (state, action) {
    if (typeof state === 'undefined') state = initialState;
    switch (action.type) {
    case GET_PROJECT_DATA:
        return Object.assign({}, state, {
            projectDatafromNet: action.projectDatafromNet
        });
    default:
        return state;
    }
};
const setProjectOriginData = projectDatafromNet => {
    return {
        type: GET_PROJECT_DATA,
        projectDatafromNet: projectDatafromNet
    };
   
};

export {
    reducer as default,
    initialState as getOriginDataInitialState,
    setProjectOriginData
};
